/**
 *
 * @param {{
 *   html?: string
 *   imageFile?: string
 *   background?: boolean
 *   landscape?: boolean
 * }[]} input
 * @returns {any} []byte of pdf
 */
function createPDF(input) {
    /**
     * @type {any[]}
     */
    let pdfDataArr = []

    let firstPage = true

    input.forEach((_p) => {
        let pData

        if (_p.html) {
            pData = context.pdf.fromHTML(_p.html, {
                marginTop: 10,
                marginRight: 0,
                marginBottom: 10,
                footerSpacing: 5,
                marginLeft: 0,
                orientation: "Portrait",
            })
        } else if (_p.imageFile) {
            pData = context.pdf.cpu("create", {
                paper: "A4",
                margin: {
                    width: 20 * 2.8346, // points
                },
                pages: {
                    1: {
                        content: {
                            image: [
                                {
                                    src: _p.imageFile,
                                    anchor: "center",
                                    // need to set width and height in points, because large images will scale out of border sometimes
                                    width: (297 - 20 - 20) * 2.8346,
                                    height: (210 - 20 - 20) * 2.8346,
                                },
                            ],
                        },
                    },
                },
            })
        } else {
            return
        }

        pdfDataArr.push(pData)

        firstPage = false
    })

    let pdfData
    if (pdfDataArr.length > 1) {
        pdfData = context.pdf.cpu("merge", pdfDataArr)
    } else {
        pdfData = pdfDataArr[0]
    }

    console.log("PDF CREATE")

    return pdfData
}

module.exports = {
    createPDF,
}
